<template>
  <div class="date-filter">
    <el-select class="rule-item" v-model="formData.rule">
      <el-option-group v-for="group in rules" :key="group.label" :label="group.label">
        <el-option
          v-for="ruleItem in group.options"
          :key="ruleItem.value"
          :value="ruleItem.value"
          :label="ruleItem.label"
        />
      </el-option-group>
    </el-select>

    <template v-if="isDuplicateCount">
      <el-select class="form-li-item" v-model="formData.symbol" placeholder="请选择">
        <el-option value=">" label="大于" />
        <el-option value="<" label="小于" />
        <el-option value=">=" label="大于等于" />
        <el-option value="<=" label="小于等于" />
        <el-option value="=" label="等于" />
      </el-select>

      <el-input-number
        v-model="formData.num"
        class="form-li-item"
        placeholder="请输入数值"
        :min="0"
        :max="10000000"
        :precision="0"
        :controls="false"
      />
    </template>

    <div class="range-content" v-show="!isDuplicateCount && isRange">
      <el-date-picker
        class="date-picker-item"
        v-model="formData.date[0]"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd HH:mm:ss"
      />
      <span :style="{ margin: '0 5px' }">至</span>
      <el-date-picker
        class="date-picker-item"
        v-model="formData.date[1]"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd HH:mm:ss"
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      formData: null
    };
  },
  props: {
    defaultFormData: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    defaultDataStatic() {
      return {
        rule: this.rules[0].options[0].value,
        date: [],
        num: undefined,
        symbol: '>'
      };
    },
    rules() {
      const normalRules = [
        { value: 'DUPLICATE_COUNT', label: '重复项计数' },
        { value: 'MONODROME', label: '单值' },
        { value: 'MULTIVALUED', label: '多值' },
        { value: 'range', label: '区间' },
        { value: 'exists_not', label: '日期为空' },
        { value: 'exists', label: '日期不为空' }
      ];
      return [{ label: '日期筛选', options: normalRules }];
    },
    isRange() {
      return this.formData.rule === 'range';
    },
    isDuplicateCount() {
      return this.formData.rule === 'DUPLICATE_COUNT';
    }
  },
  created() {
    this.formData = cloneDeep(this.defaultDataStatic);
    if (this.defaultFormData) {
      this.formData = { ...this.formData, ...this.defaultFormData };
    }
    this.$watch(
      'formData',
      () => {
        this.$emit('change');
      },
      { deep: true }
    );
  },
  methods: {
    validateInfo() {
      if (this.isDuplicateCount) {
        if (!this.formData.num && this.formData.num !== 0) {
          throw new Error('请输入标签个数');
        }
      } else if (this.isRange && (this.formData.date || []).filter(date => !!date).length < 1) {
        throw new Error('请选择日期区间');
      }
      return this.formData;
    }
  }
};
</script>

<style lang="scss" scoped>
.date-filter {
  height: 100%;
  display: flex;
  align-items: center;

  .rule-item {
    width: 160px;
  }

  .range-content {
    display: flex;
    align-items: center;
    margin-left: 5px;

    .date-picker-item {
      width: 160px;
    }
  }

  .form-li-item {
    width: 160px;
    margin-left: 5px;
    &.search-item {
      width: 344px;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
